import { AdBanner } from '@techminds/ad-banner';
import classNames from 'classnames/bind';
import { useContext, useState } from 'react';

import { DeviceContext, DeviceType } from 'contexts/device';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

const FIRST_BANNER = 'first_banner';
const SECOND_BANNER = 'second_banner';

const wingBanner = [
  {
    key: FIRST_BANNER,
    title: '여행 전에 필수 체크!',
    shortTitle: '여행 전 체크',
    items: [
      { adUnitId: 'tm_travel_flight_right_side_banner_first_0', uct: 'KR' },
      { adUnitId: 'tm_travel_flight_right_side_banner_first_1', uct: 'KR' },
      { adUnitId: 'tm_travel_flight_right_side_banner_first_2', uct: 'KR' },
      { adUnitId: 'tm_travel_flight_right_side_banner_first_3', uct: 'KR' },
      { adUnitId: 'tm_travel_flight_right_side_banner_first_4', uct: 'KR' },
    ],
  },
  {
    key: SECOND_BANNER,
    title: '진행 중인 이벤트',
    shortTitle: '진행 중 이벤트',
    items: [
      { adUnitId: 'tm_travel_flight_right_side_banner_second_0', uct: 'KR' },
      { adUnitId: 'tm_travel_flight_right_side_banner_second_1', uct: 'KR' },
      { adUnitId: 'tm_travel_flight_right_side_banner_second_2', uct: 'KR' },
      { adUnitId: 'tm_travel_flight_right_side_banner_second_3', uct: 'KR' },
      { adUnitId: 'tm_travel_flight_right_side_banner_second_4', uct: 'KR' },
    ],
  },
];

const SideBanner = () => {
  const device = useContext(DeviceContext);
  const [firstSideBannerLoadedList, setFirstSideBannerLoadedList] = useState(
    new Array(5).fill(false),
  );
  const [secondSideBannerLoadedList, setSecondSideBannerLoadedList] = useState(
    new Array(5).fill(false),
  );

  const [canVisibleFirstSideBanner, canVisibleSecondSideBanner] = [
    firstSideBannerLoadedList,
    secondSideBannerLoadedList,
  ].map(loadedList => loadedList.some(v => v));

  if (device === DeviceType.MOBILE) {
    return null;
  }

  return (
    <div className={cx('SideBanner')}>
      {wingBanner.map(banner => {
        const canVisible =
          banner.key === FIRST_BANNER
            ? canVisibleFirstSideBanner
            : canVisibleSecondSideBanner;

        const sideBannerLoadedList =
          banner.key === FIRST_BANNER
            ? firstSideBannerLoadedList
            : secondSideBannerLoadedList;

        return (
          <div
            className={cx('section', !canVisible && 'hidden')}
            key={banner.key}
          >
            <div className={cx('header')}>
              <span data-media="narrow">{banner.shortTitle}</span>
              <span data-media="full">{banner.title}</span>
            </div>
            <menu className={cx('list')}>
              {banner.items.map((item, index) => {
                const loadedListSetter =
                  banner.key === FIRST_BANNER
                    ? setFirstSideBannerLoadedList
                    : setSecondSideBannerLoadedList;

                const handleAdLoaded = () => {
                  loadedListSetter(prev => {
                    const copiedPrevLoadedList = [...prev];
                    copiedPrevLoadedList[index] = true;
                    return copiedPrevLoadedList;
                  });
                };

                return (
                  <li
                    className={cx(
                      'item',
                      !sideBannerLoadedList[index] && 'hidden',
                    )}
                    key={item.adUnitId}
                  >
                    <AdBanner adSlotInfo={item} onAdLoaded={handleAdLoaded} />
                  </li>
                );
              })}
            </menu>
          </div>
        );
      })}
    </div>
  );
};

export default SideBanner;
